/* eslint-disable */
import React from 'react';
import { WELFARE_STATUS_INFO } from '../config';
import styles from '../styles/common.less';

const CardStatusTabs = ({ onStatusChange, curStatus, statusInfo = WELFARE_STATUS_INFO }) => {
  return (
    <ul className={styles['card-status']}>
      {statusInfo.map(statusItem => (
        <li
          key={statusItem.id}
          onClick={() => onStatusChange(statusItem.id)}
          className={`${styles['status-item']} ${
            statusItem.id === curStatus ? styles['active'] : ''
          }`}
        >
          {statusItem.label}
        </li>
      ))}
    </ul>
  );
};
export default CardStatusTabs;
